import { render, staticRenderFns } from "./offer-center-table.vue?vue&type=template&id=da3f7262"
import script from "./offer-center-table.vue?vue&type=script&lang=js"
export * from "./offer-center-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports